import type { NavItem } from '@/app/nav/collect'

/**
 * "Settings" is the legacy menu entry the shell already declares (`src/modules/shell/nav.ts`, id `settings`, common and
 * accounting menus, `…/settings/configuration`); legacy had no other settings entry, so the module adds none.
 */
const nav: NavItem[] = []

export default nav
